import { useMutation, useQueryClient } from 'react-query';
import * as api from '../../services/api';
import { HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY } from './useHelpDeskEmployeeTickets';
import { getHelpDeskTicketQueryKey } from './useHelpDeskTicket';
import { getHelpDeskMessagesQueryKey } from './useHelpDeskMessages';
import { HELP_DESK_TICKETS_QUERY_KEY } from './useHelpDeskTickets';
import { HELP_DESK_UNREAD_COUNT_QUERY_KEY } from './useHelpDeskUnreadCount';

/**
 * Mutation hook to update a help desk ticket (resolve, snooze, close, priority, category, assignee, isRead, etc.).
 * Invalidates the single ticket, tickets list, messages and unread counts on success
 * (ticket updates create system events).
 * @param {Object} params
 * @param {string|number} params.accountId
 * @param {string|number} params.ticketId
 */
const useHelpDeskUpdateTicket = ({ accountId, ticketId }) => {
  const queryClient = useQueryClient();

  const { mutate: updateTicket, mutateAsync: updateTicketAsync, isLoading } = useMutation(
    (body) => api.updateHelpDeskTicket({ accountId, ticketId, ...body }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(getHelpDeskTicketQueryKey(accountId, ticketId));
        queryClient.invalidateQueries(getHelpDeskMessagesQueryKey(accountId, ticketId));
        queryClient.invalidateQueries({
          predicate: (query) => Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_TICKETS_QUERY_KEY
        });
        queryClient.invalidateQueries({
          predicate: (query) => Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_UNREAD_COUNT_QUERY_KEY
        });
        queryClient.invalidateQueries({
          predicate: (query) =>
            Array.isArray(query.queryKey) && query.queryKey[0] === HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY
        });
      }
    }
  );

  return { updateTicket, updateTicketAsync, isLoading };
};

export default useHelpDeskUpdateTicket;
